import React from "react"
import PropTypes from "prop-types"
import styled, { css } from "styled-components"
import { Link } from "gatsby"
import { breakpoints } from "../../../theme"
import * as Icons from "@bw/icons"

const TeaserBody = styled.div`
  position: relative;
  padding: 25px;
  transition: opacity 3ms ease-in-out;
`

const TeaserStyle = css`
  text-decoration: none;
  width: 100%;
  display: grid;
  grid-gap: 5px;
  color: currentColor;

  &:hover {
    > div {
      opacity: 0.85;
    }
    > Link {
      transform: translateX(10px);
    }
  }
`
const Title = styled.h3`
  gap: 15px;
  font-weight: 700;
  font-size: 22px;
  line-height: 27px;
  display: flex;
  align-items: center;

  color: #000000;

  &:first-child {
    margin-top: 0;
  }
`

const Icon = styled.div`
  width: 38px;
  height: 38px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: var(--light);
`

const Excerpt = styled.div`
  font-size: 14px;
  line-height: 1.8;

  @media (min-width: ${breakpoints.medium}px) {
    display: block;
    margin-top: 0.8em;
  }
`
const Button = styled(Link)`
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
  letter-spacing: 0.02em;
  cursor: pointer;
  color: #000000;
  margin: 45px 0 0 0;
`

const StyledLink = styled(Link)`
  ${TeaserStyle}
`
const StyledA = styled.a`
  ${TeaserStyle}
`
const StyledDiv = styled.div`
  ${TeaserStyle}
`

const SimpleTeaser = ({
  buttonLabel,
  title,
  excerpt,
  to,
  icon,
  href,
  onClick,
}) => {
  const hasContent = title !== null || excerpt !== null
  const Card = () => (
    <>
      {hasContent && (
        <TeaserBody>
          {title && (
            <Title>
              {icon && <Icon>{icon}</Icon>}
              {title}
            </Title>
          )}
          {excerpt && <Excerpt>{excerpt}</Excerpt>}
          {buttonLabel && (
            <Button $primary to={to}>
              {buttonLabel}
              <Icons.ArrowRight />
            </Button>
          )}
        </TeaserBody>
      )}
    </>
  )
  switch (true) {
    case to !== null:
      return (
        <StyledLink to={to}>
          <Card />
        </StyledLink>
      )

    case href !== null:
      return (
        <StyledA href={href} target="_blank">
          <Card />
        </StyledA>
      )

    case onClick !== null:
      return (
        <StyledDiv onClick={onClick}>
          <Card />
        </StyledDiv>
      )

    default:
      throw new Error(
        "Unsupported type of teaser. Should use one of these props: to, href or onClick"
      )
  }
}

SimpleTeaser.propTypes = {
  title: PropTypes.string.isRequired,
  excerpt: PropTypes.string,
  buttonLabel: PropTypes.string,
  to: PropTypes.string,
  icon: PropTypes.element,
  onClick: PropTypes.func,
  href: PropTypes.string,
}

export { SimpleTeaser }
